import React, { useState } from "react";
import { useSelector } from "react-redux";

import "./AssessmentSideDrawer.scss";
import Physio from "../../../organisms/Progress/Physio/Physio";
import Tabs from "../../../atoms/Tabs/Tabs";
import AssessmentWrapper from "../AssessmentWrapper/AssessmentWrapper";
import AssessmentAISummary from "../../AssessmentAISummary";
import AIGeneratedDietPlan from "../../AIGeneratedDietPlan";
import AssessmentQnA from "../../AssessmentQnA/AssessmentQnA";
import { RootState } from "../../../store/store";

const AssessmentSideDrawer: React.FC<{ 
  onAutofill?: (dietPlanData: any) => void;
  onCloseToIndex?: () => void;
}> = ({ onAutofill, onCloseToIndex }) => {
  const tabs = [
    {
      label: "Goals",
      value: "GOALS",
    },
    {
      label: "Assessment (Old)",
      value: "ASSESSMENT",
    },
    {
      label: "Assessment (New)",
      value: "ASSESSMENT_NEW",
    },
    // Temporarily hiding tab as it's product requirement.
    // {
    //   label: "Assessment Summary",
    //   value: "ASSESSMENT_SUMMARY",
    // },
    {
      label: "AI Generated Diet Plan",
      value: "AI_GENERATED_DIET_PLAN",
    },
  ];
  const [activeTab, setActiveTab] = useState(tabs[0].value);
  const patientId = useSelector(
    (state: RootState) => state.patient.patientDetails?.data?.patient_id,
  );

  return (
    <div className="assessment-side-drawer">
      <div className="tabs-container">
        <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} />
      </div>
      <div className="tabs-content">
        {activeTab === "ASSESSMENT" ? (
          <AssessmentWrapper />
        ) : activeTab === "ASSESSMENT_NEW" ? (
          <AssessmentQnA assessmentId="diet" patientId={patientId || undefined} />
        ) : activeTab === "GOALS" ? (
          <Physio mode="view" />
        ) : activeTab === "ASSESSMENT_SUMMARY" ? (
          <AssessmentAISummary />
        ) : activeTab === "AI_GENERATED_DIET_PLAN" ? (
          <AIGeneratedDietPlan onAutofill={onAutofill} onCloseToIndex={onCloseToIndex} />
        ) : null}
      </div>
    </div>
  );
};

export default AssessmentSideDrawer;
